/* eslint-disable */

import type { SignUpLang } from "./types/SignUpLang";

let data: SignUpLang | undefined;

export type { SignUpLang };

export default function SignUpLangFactory(): SignUpLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setSignUpLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/SignUpLangDef").then(({ SignUpLangDef }) => {
      data = SignUpLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/SignUpLangDef").then(({ SignUpLangDef }) => {
      data = SignUpLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/SignUpLangDef").then(({ SignUpLangDef }) => {
      data = SignUpLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/SignUpLangDef").then(({ SignUpLangDef }) => {
      data = SignUpLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

